const planPage = {
  roadmapTitle: "מפת דרכים — vBrain.io",
  overallProgress: "התקדמות כללית",
  phase: "שלב",
  phaseRoutes: "ראוטים בשלב",
  statusComplete: "הושלם",
  statusInProgress: "בביצוע",
  statusPlanned: "מתוכנן",
  clickToChangeStatus: "לחץ לשינוי סטטוס",
  noRoutes: "אין ראוטים",
  notes: "הערות",
  notesPlaceholder: "הערות לשלב — סיכום, סיכונים, יעדים...",
  realtimeConnected: "מחובר",
  realtimeConnecting: "מתחבר...",
  realtimeDisconnected: "מנותק",
  phase1Name: "תשתית ליבה",
  phase1Desc: "Sidebar, Layout, Layers, Settings, Automations",
  phase2Name: "עורך מסמכים",
  phase2Desc: "Canvas Editor עם מערכת שדות ותבניות",
  phase3Name: "מפת סיפורים",
  phase3Desc: "Story Map עם גרירה בשלוש שכבות",
  phase4Name: "מרכז AI",
  phase4Desc: "Claude API עם מצבי עבודה וסטרימינג",
  phase5Name: "עמודי תוכן",
  phase5Desc: "Design System, Functional Map, Architecture, Plan, Entities",
} as const;
export default planPage;
